import { CategoryGroupImportPage } from "@/features/category-group/pages/CategoryGroupImportPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/category-group/$id/import")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <CategoryGroupImportPage id={id} />;
}
